import { toast } from 'sonner';
import { isNil } from 'ramda';

// lang
import { __ } from '@wordpress/i18n';

/**
 * Handle success msg displaying
 *
 * @param {string} msg
 * @param {object} args
 *
 * @returns (void)
 */
const handleSuccessAndDisplay = (msg, args = {}) => {
    const config = {
        'className': 'uniSonnerNotifications toastSuccess',
        ...args
    }

    toast.success(isNil(msg) ? __('Operazione completata', 'soundbetween') : msg, config);
};

export default handleSuccessAndDisplay;